window.addEventListener('load', () => {
    const menu = document.querySelector(".MobileMenu");
    const menuParents = document.querySelectorAll(".MobileMenu .menu .menu-item.menu-item-has-children");

    if (!menu) return;

    const is_open = () => {
        return menu.getAttribute("data-open") === "true";
    }

    const update_body = () => {
        if (is_open()) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }

    const open = () => {
        menu.setAttribute("data-open", "true");
        update_body();
    }

    const close = () => {
        menu.setAttribute("data-open", "false");
        update_body();
    }

    const toggle = () => {
        if (is_open()) {
            close();
        } else {
            open();
        }
    }

    const trigger = document.querySelector(".MobileMenu__trigger");

    trigger.addEventListener("click", () => {
        toggle();
    });

    if (!menuParents) return;

    menuParents.forEach((parent) => {
        const link = parent.querySelector("* > a");
        const submenu = parent.querySelector("* > .sub-menu");

        if (!link || !submenu) return;

        link.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            submenu.classList.toggle("is-open");

            menuParents.forEach((otherParent) => {
                if (otherParent !== parent) {
                    otherParent.querySelector("* > .sub-menu")?.classList.remove("is-open");
                }
            })
        })
    });
});